var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25H3.75C3.55109 2.25 3.36032 2.32902 3.21967 2.46967C3.07902 2.61032 3 2.80109 3 3V4.9425C3 5.33475 3.15975 5.72025 3.43725 5.99775L7.5 10.0605V15.75C7.50015 15.8778 7.53291 16.0034 7.59517 16.115C7.65744 16.2266 7.74716 16.3204 7.85583 16.3876C7.9645 16.4548 8.08853 16.4932 8.21618 16.4991C8.34382 16.505 8.47086 16.4782 8.58525 16.4213L11.5853 14.9213C11.8395 14.7938 12 14.5343 12 14.25V10.0605L16.0628 5.99775C16.3403 5.72025 16.5 5.33475 16.5 4.9425V3C16.5 2.80109 16.421 2.61032 16.2803 2.46967C16.1397 2.32902 15.9489 2.25 15.75 2.25ZM10.7198 9.21975C10.65 9.28928 10.5946 9.37192 10.5569 9.46293C10.5192 9.55393 10.4999 9.65149 10.5 9.75V13.7865L9 14.5365V9.75C9.00014 9.65149 8.9808 9.55393 8.94309 9.46293C8.90537 9.37192 8.85003 9.28928 8.78025 9.21975L4.5 4.9425V3.75H15.0008L15.0023 4.93725L10.7198 9.21975Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.e5701346083eb1f1e8ede05fea6a55ce.svg";
export { ForwardRef as ReactComponent };